export const ADD_PARTNER = gql`
    mutation createAddPartnerApplication($input: AddPartnerInput) {
        addPartner(input: $input) {
            id
            step
            partnerType
            partnerId
            pi_BusinessType
            pi_legalCompanyName
            pi_website
            pi_registeredNumber
            pi_vatRegistered
            pi_tradingName
            pi_vatNumber
            pi_accountManager
            pi_creditLimit
            pi_paymentTerms
            ai_ra_eircode
            ai_ra_addressLine1
            ai_ra_addressLine2
            ai_ra_city
            ai_ra_country
            ai_ra_county
            ai_ra_countryCode
            ai_ra_tradingAddressSameAsRegisteredAddress
            ai_ta_eircode
            ai_ta_addressLine1
            ai_ta_addressLine2
            ai_ta_city
            ai_ta_country
            ai_ta_county
            ai_ta_countryCode
            pci_firstName
            pci_lastName
            pci_email
            pci_telephoneNumber
            pci_mobilePhoneNumber
            pci_position
            pci_ra_eircode
            pci_ra_addressLine1
            pci_ra_addressLine2
            pci_ra_city
            pci_ra_country
            pci_ra_county
            pci_ra_countryCode
            usePrimaryContactInformationForBillingContact
            usePrimaryContactInformationForServiceContact
            bci_firstName
            bci_lastName
            bci_email
            bci_telephoneNumber
            bci_mobilePhoneNumber
            bci_position
            bci_ra_eircode
            bci_ra_addressLine1
            bci_ra_addressLine2
            bci_ra_city
            bci_ra_country
            bci_ra_countryCode
            sci_firstName
            sci_lastName
            sci_email
            sci_telephoneNumber
            sci_mobilePhoneNumber
            sci_position
            sci_ra_eircode
            sci_ra_addressLine1
            sci_ra_addressLine2
            sci_ra_city
            sci_ra_country
            sci_ra_countryCode
            bicNumber
            ibanNumber
            accountNumber
            sortCode
            commissionFrequency
            partnerContractSignedAt
            directors
            companyIncorporationDate
            currency
            countryDetails {
                alpha2Code
                name
            }
            country
            contract
            assignedOffers {
                id
                name
                term
                type
                primaryProducts {
                    id
                    name
                    description {
                        type
                        text
                    }
                }
                secondaryProducts {
                    id
                    name
                    description {
                        type
                        text
                    }
                }
            }
            assignedTransactionOffers {
                id
                offerName
                revenueShare
            }
        }
    }
`;
